import React from 'react';
import { styled } from '@mui/material/styles';
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'RegistrationConfirmed';

const classes = {
  root: `${PREFIX}-root`,
  form: `${PREFIX}-form`,
  title: `${PREFIX}-title`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  [`& .${classes.form}`]: {
    width: '600px',
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '30px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },

  [`& .${classes.title}`]: {
    textAlign: 'center',
    paddingBottom: '20px',
  },
}));

const RegistrationConfirmed = props => {
  return (
    <Root className={classes.root}>
      <div className={classes.form}>
        <Typography className={classes.title} variant='h2'>
          Аккаунт подтверждён.
        </Typography>
        <Typography>Можете пользоваться.</Typography>
        <Button
          color='primary'
          variant='contained'
          component={RouterLink}
          to='/sign-in'
          size='large'
          sx={{ mt: 2 }}
        >
          Войти
        </Button>
      </div>
    </Root>
  );
};

export default RegistrationConfirmed;
